// extracted by mini-css-extract-plugin
export default {"MainContainer":"Login_MainContainer__cfxZI","Form":"Login_Form__CYn+T","LinkButton":"Login_LinkButton__DQV4v"};